//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export bankrecledgerconfig
export const RestartDemoConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/agentPanel/demo",
      component: FuseLoadable({
        loader: () => import("./RestartDemo.js")
      })
    }
  ]
  //end routes
};
